





import {Component, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
const style = namespace('style')
@Component({
  name: "StyleApp"
})
export default class StyleApp extends Vue{
  @style.Getter('style') protected style: any
  get userStyle() {
    return {
      '--base-color-text': this.style.sidebar.base_text_color,
      '--base_background_color': this.style.sidebar.base_background_color,
    }
  }
}
